import React from "react";

class Gallery extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      gallerySelected: 0,
      gallery: [
        // Gallery Images/Videos
        { type: "image", url: "./images/gta_sumol_offset01.png" },
        { type: "image", url: "./images/gta_sumol_offset02.png" },
        { type: "image", url: "./images/gta_sumol_offset03.png" },
        { type: "image", url: "./images/gta_sumol_offset04.png" },
        { type: "image", url: "./images/gta_sumol_offset05.png" },
        { type: "image", url: "./images/gta_sumol_offset06.png" },
        { type: "image", url: "./images/gta_sumol_offset07.png" },
        { type: "image", url: "./images/gta_sumol_offset08.png" },
        { type: "image", url: "./images/gta_sumol_offset09.png" },
        { type: "image", url: "./images/gta_sumol_offset10.png" },
        { type: "image", url: "./images/gta_sumol_offset11.png" },
      ],
    };

    this.slideNext = this.slideNext.bind(this);
    this.slidePrevious = this.slidePrevious.bind(this);
    this.selectGallery = this.selectGallery.bind(this);
    this.startAutoSlide = this.startAutoSlide.bind(this);

    this.timeoutSlide = null;
  }

  componentDidMount() {
    this.startAutoSlide();
  }

  componentWillUnmount() {
    clearTimeout(this.timeoutSlide);
  }

  slideNext() {
    let nextID = this.state.gallerySelected + 1;
    if (nextID >= this.state.gallery.length) nextID = 0;
    this.setState({ gallerySelected: nextID });
    clearTimeout(this.timeoutSlide);
    this.startAutoSlide();
  }

  slidePrevious() {
    let nextID = this.state.gallerySelected - 1;
    if (nextID < 0) nextID = this.state.gallery.length - 1;
    this.setState({ gallerySelected: nextID });
    clearTimeout(this.timeoutSlide);
    this.startAutoSlide();
  }

  selectGallery(id) {
    this.setState({ gallerySelected: id });
    clearTimeout(this.timeoutSlide);
    this.startAutoSlide();
  }

  startAutoSlide() {
    this.timeoutSlide = setTimeout(
      function () {
        this.slideNext();
      }.bind(this),
      5000
    );
  }

  render() {
    return (
      <section id="gallery">
        <div className="container position-relative">
          <div className="title">
            <span className="outline">Galeria</span>
            <span className="normal">Galeria</span>
          </div>
          <div className="banner">
            <img src="./images/gallerybanner.png" alt="GalleryBG"></img>
          </div>
          <div className="slideshow">
            <div className="screen">
              <div className="selectedGallery">
                <div className="goleft" onClick={this.slidePrevious}>
                  <img src="./images/slidearrow.png" alt="slidearrow"></img>
                </div>
                <div className="goright" onClick={this.slideNext}>
                  <img src="./images/slidearrow.png" alt="slidearrow"></img>
                </div>
                <img src={this.state.gallery[this.state.gallerySelected].url} alt="GallerySelected"></img>
              </div>

              <div className="options">
                {this.state.gallery.map((galleryitem, key) => (
                  <div onClick={() => this.selectGallery(key)} key={key} className={"option" + (this.state.gallerySelected === key ? " selected" : "")}>
                    <img src={galleryitem.url} alt="Gallery"></img>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Gallery;
